export default __webpack_public_path__ + "static/media/logo_login.38e886f8.png";